import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const ThrowInPopup = new PopupBuilder('Throw In', {
  incident_id: BasketballIncidentId.ThrowIn,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
